import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export class ChartLegendBox extends React.Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    previousDateRangeCount: PropTypes.number.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  initializeDeltaTooltip = (title) => {
    return function (el) {
      if (!el) return;

      $(el).tooltip({
        title: title,
      });
    };
  };

  render() {
    const delta =
      (this.props.count - this.props.previousDateRangeCount) /
      this.props.previousDateRangeCount;
    const formattedDelta =
      $h.commaizeInt(Math.abs(Math.round(delta * 100))) + '%';
    const deltaTextClasses = classNames('u-fs14', {
      'u-tcGreen': delta > 0,
      'u-tcRed': delta < 0,
      'u-displayNone': delta === 0 || !_.isFinite(delta),
    });
    const deltaIconClasses = classNames('fa', {
      'fa-caret-up': delta > 0,
      'fa-caret-down': delta < 0,
    });
    const circleClasses = classNames('u-mr2x', {
      'u-displayNone': !this.props.color,
      'u-displayInlineBlock': this.props.color,
    });
    return (
      <div className="u-p6x u-tcGrayDarker">
        <div
          className={circleClasses}
          style={{
            height: 12,
            width: 12,
            background: this.props.color,
            borderRadius: '50%',
          }}
        ></div>
        {this.props.label}
        <br />
        <h5 className="u-fw700 u-fs22 u-mb0x">
          {$h.commaizeInt(this.props.count)}
          &nbsp; &nbsp;
          <span
            className={deltaTextClasses}
            ref={this.initializeDeltaTooltip(
              'Change since previous ' + this.props.dayCount + '-day period',
            )}
          >
            <i className={deltaIconClasses}></i>
            &nbsp;
            {formattedDelta}
          </span>
        </h5>
      </div>
    );
  }
}
